import { useQuery } from 'react-query';

import { ClaimService } from '@/api';

export const useGetClaimGroupStateQuery = ({
  claimGroupId,
}: {
  claimGroupId?: string;
}) => {
  const { data: claimContextsState, isLoading } = useQuery(
    ['useGetClaimGroupStateQuery', { claimGroupId }],
    async () => {
      if (!claimGroupId) {
        return undefined;
      }

      const response = await ClaimService.getClaimGroupStateQuery({
        claimGroupId,
      });

      if (response.failure) {
        return undefined;
      }

      return response.value;
    },
    {
      enabled: !!claimGroupId,
    },
  );

  return {
    claimContextsState,
    isLoading,
  };
};
